import axios from 'axios';
import { getAccessTokenJWT } from 'utils/okta';
import { appConfig } from 'config/appConfig';
import okta from 'constants/okta';

const APIEndpoint = 'sharedneedsassessments';

export const save = async (naId, userId) => {
  const payload = {
    NeedsAssessmentsId: naId,
    UserId: userId,
  };

  return axios({
    method: 'post',
    url: appConfig.API_URL + '/' + APIEndpoint,
    data: payload,
    headers: {
      Authorization: okta.Bearer + getAccessTokenJWT(),
      'subscription-key': appConfig.API_SUBSCRIPTION_KEY,
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // TO-DO. Logging
      // control 401. okta redirection
      console.error(error);
      throw Error(error);
    });
};

export const remove = async (naId, userId) => {
  const payload = {
    NeedsAssessmentsId: naId,
    UserId: userId,
  };

  return axios({
    method: 'delete',
    url: appConfig.API_URL + '/' + APIEndpoint,
    data: payload,
    headers: {
      Authorization: okta.Bearer + getAccessTokenJWT(),
      'subscription-key': appConfig.API_SUBSCRIPTION_KEY,
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // TO-DO. Logging
      // control 401. okta redirection
      console.error(error);
      throw Error(error);
    });
};
